import {StyleSheet} from 'react-native';

import {indent} from '/constant/layout.constant';
import {cloudLight} from '/theme/color/on.color';

export const styles = StyleSheet.create({
  base: {
    marginVertical: indent,
  },
  label: {
    marginBottom: indent * 0.5,
  },
  value: {
    flexDirection: 'row',
  },
  order: {
    paddingVertical: indent,
    borderBottomWidth: 1,
    borderBottomColor: cloudLight,
    marginHorizontal: indent,
  },
  headerContainer: {
    marginTop: indent,
    borderBottomWidth: 1,
    borderBottomColor: cloudLight,
  },
  header: {
    marginBottom: indent,
  },
  orderLine1: {
    flex: 1,
    flexDirection: 'row',
  },
  orderDate: {
    flex: 1,
  },
  orderAmount: {
    flex: 0,
  },
  loadingBoxOrderNumber: {
    height: 10,
    width: 130,
  },
  loadingBoxOrderDate: {
    height: 15,
    width: 100,
    marginBottom: 5,
  },
  loadingBoxOrderTotal: {
    height: 20,
    width: 60,
  },
  loadingBoxCancellationDate: {
    height: 30,
    width: 150,
  },
});
